import { Button, Icon, Text, Tooltip, TooltipContent, TooltipTrigger } from '@flatfile/baseline'
import React, { useState } from 'react'

interface CustomCopyButtonProps {
  value: string
}

export const CustomCopyButton: React.FC<CustomCopyButtonProps> = ({ value }) => {
  const [copied, setCopied] = useState(false)

  const copy = () => {
    navigator.clipboard.writeText(value)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant='ghost'
          size='sm'
          className='p-0 h-auto flex items-center gap-1 !text-xs font-mono'
          onClick={copy}
        >
          <span className='font-mono text-xs'>{value}</span>
          {copied ? (
            <Icon name='checkmark-2' size={12} className='text-gray-400' />
          ) : (
            <Icon name='square-behind-square' size={12} className='text-gray-400' />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent className='flex items-center px-2 py-1'>
        <Text variant='body' className='text-sm'>
          {copied ? 'Copied!' : 'Copy to clipboard'}
        </Text>
      </TooltipContent>
    </Tooltip>
  )
}
